import { CustomTitle } from '@/components';
import React, { useState } from 'react';
import EvaluationForm from './EvaluationForm';
import ReviewFlowForm from './ReviewFlowForm';

interface GxPSettingDrawerProps {
  onClose?: () => void;
}

const GxPSettingDrawer: React.FC<GxPSettingDrawerProps> = ({ onClose }) => {
  const [innerTab, _setInnerTab] = useState('evaluation');
  // const tabs = [
  //   {
  //     key: 'evaluation',
  //     label: 'Evaluation & release',
  //   },
  //   {
  //     key: 'review',
  //     label: 'Review flows',
  //   },
  // ];
  return (
    <>
      <div className='drawer-sticky-header-section'>
        <div
          style={{
            margin: '0px 32px',
          }}
        >
          <CustomTitle
            text={'GxP settings'}
            fontSize={24}
            fontWeight='700'
            lineHeight='32px'
            color='var(--text-primary)'
            marginBottom={0}
          />
        </div>

        {/* <CustomTabs tabs={tabs} activeTab={innerTab} onChange={setInnerTab} /> */}
      </div>

      <div className='scrollable-content'>
        {innerTab === 'evaluation' ? (
          <EvaluationForm onClose={onClose} />
        ) : (
          <ReviewFlowForm />
        )}
      </div>
    </>
  );
};

export default GxPSettingDrawer;
